.container {
  display: flex;
  padding: 0.5rem;
  align-items: flex-start;
  gap: 1rem;
  align-self: stretch;
  position: relative;
  z-index: 50;
}
.container:not(:last-child) {
  border-bottom: 1px solid var(--static-divider-standard, rgba(0, 0, 0, 0.12));
}
.container:hover {
  background-color: var(--static-background-weak);
  cursor: pointer;
}

.productInfo {
  flex: 1 0 0;
  min-width: 0;
}

.productImage {
  flex: 0 0 auto;
}

.itemName {
  line-clamp: 2;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
}

.minWidth0 {
  min-width: 0;
}

.listItemContent {
  width: 100%;
  min-width: 0;
}

.listItemTitle {
  display: block;
  max-width: 80%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.listItemRow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
}
